(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kosmo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      var canvas = root.querySelector(".kosmo-hero__stars");
      if (!canvas || !canvas.getContext || canvas.dataset.khReady) return;
      canvas.dataset.khReady = "1";

      var ctx = canvas.getContext("2d");
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var stars = [];
      var w = 0;
      var h = 0;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var mx = 0;
      var my = 0;

      function resize() {
        var r = canvas.getBoundingClientRect();
        w = r.width;
        h = r.height;
        if (!w || !h) return;
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var count = Math.round((w * h) / 6200);
        stars = [];
        for (var i = 0; i < count; i++) {
          stars.push({
            x: Math.random() * w,
            y: Math.random() * h,
            z: Math.random() * 0.8 + 0.2,
            t: Math.random() * Math.PI * 2,
            s: Math.random() * 0.9 + 0.15
          });
        }
      }

      function draw(time) {
        if (!w || !h) {
          resize();
        }
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < stars.length; i++) {
          var st = stars[i];
          var px = st.x + (reduce ? 0 : mx * st.z * 22);
          var py = st.y + (reduce ? 0 : my * st.z * 22) + (reduce ? 0 : time * 0.004 * st.z);
          py = ((py % h) + h) % h;
          var tw = reduce ? 0.7 : 0.55 + 0.45 * Math.sin(st.t + time * 0.001 * st.s);
          ctx.globalAlpha = tw * (0.35 + st.z * 0.65);
          ctx.fillStyle = st.z > 0.7 ? "#cfe0ff" : "#8fa6d8";
          ctx.beginPath();
          ctx.arc(px, py, st.z * 1.5, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.globalAlpha = 1;
        if (!reduce) requestAnimationFrame(draw);
      }

      window.addEventListener("resize", resize, { passive: true });
      root.addEventListener("mousemove", function (e) {
        mx = e.clientX / window.innerWidth - 0.5;
        my = e.clientY / window.innerHeight - 0.5;
      }, { passive: true });

      resize();
      if (reduce) draw(0);
      else requestAnimationFrame(draw);
    }

    function initAll() {
      var nodes = document.querySelectorAll(".kosmo-hero");
      for (var i = 0; i < nodes.length; i++) initHero(nodes[i]);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initAll);
    } else {
      initAll();
    }

    document.addEventListener("shopify:section:load", function (e) {
      var el = e.target.querySelector && e.target.querySelector(".kosmo-hero");
      if (el) initHero(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
